<h2 mat-dialog-title style="margin: 0px">{{ 'nav.dialog.login.success' | translate }}</h2>